module.exports = __webpack_public_path__ + "static/media/logo-black.625a2996.svg";